import { Context } from "@nuxt/types";

import Api from "@/utils/api";
import debounce from "@/utils/debounce";

interface GetParams {
  ids?: string[];
  displayNames?: string[];
}

export default class ProfilesApi extends Api {
  readonly url = `/v2/profiles${process.client ? "/" : ""}`;

  constructor($axios: Context["$axios"]) {
    super("profileService", $axios);
  }

  async get({ ids, displayNames }: GetParams) {
    return await this.request<ManyProfilesResponse>({
      method: "GET",
      params: {
        ids,
        display_names: displayNames,
      },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: 10 })
  async getOne(...ids: string[]) {
    return await this.get({ ids });
  }
}
